import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";

const VALID_DOMAINS = ['cellpodium.com','s5-tech.com']

@Component({
  selector: 'app-fbscenarios',
  templateUrl: './fbscenarios.component.html',
  styleUrls: ['./fbscenarios.component.css']
})
export class FbscenariosComponent extends BaseComponent implements OnInit  {

  scenarios: any = []
  scenario: any = {}
  playersIter: any

  newScenarioName: string

  worldsRef: any;
  worlds: any; //downloaded worlds from database
  worldskeys: any = [] //keys of properties of worlds {id:0,name: "demo"}
  worldkey = 0 //index for select

  lessonplansRef: any;
  lessonplans: any; //downloaded lessonplns from database
  lessonplanskeys: any = [] //keys of properties of lessonplns {id:0,name: "demo"}
  lessonplankey = 0 //index for select

  showModal = false
  showModalNewScenario = false
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  private googleAuthProvider = new GoogleAuthProvider();

  constructor(injector: Injector) {
    super(injector)
  }
  
  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }
  async getData() {
    this.loader.show()
    const scenarios = ref(this.database, 'scenarios');
    const snapshot = await get(scenarios);
    if (snapshot.exists()) {
      const fbscenarios = snapshot.val();
      this.scenarios = this.collectionToArrayFB(fbscenarios)
    }

    this.worldsRef = ref(this.database, 'worlds');
    const snapshot2 = await get(this.worldsRef);
    if (snapshot2.exists()) {
      this.worlds = snapshot2.val();
      this.worldskeys = this.getKeys(this.worlds)
    }

    this.lessonplansRef= ref(this.database, 'lessonplans');
    const snapshot3 = await get(this.lessonplansRef);
    if (snapshot3.exists()) {
      this.lessonplans = snapshot3.val();
      this.lessonplanskeys = this.getKeys(this.lessonplans)
    }

    this.loader.hide()
  }

  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }

  async updateScenario(){
    // only update the selected scenario
    const scenRef = ref(this.database, 'scenarios/'+this.scenario.property);
    this.scenario.world = this.worldskeys[this.worldkey].name
    this.scenario.lessonplan = this.lessonplanskeys[this.lessonplankey].name
    const fbSceneario =this.removeKeyAndPropertyFB(this.scenario)
    await set(scenRef, fbSceneario);
    this.showModal = false
  }
  
  async renameScenario(){
    // add a new property with the new name
    const newname = this.newScenarioName
    const scenRef = ref(this.database, 'scenarios/'+this.newScenarioName);
    const fbSceneario =this.removeKeyAndPropertyFB(this.scenario)
    await set(scenRef, fbSceneario);
    await this.removeOneProperty('scenarios',this.scenario.property)
    this.showModal = false
    this.getData()
  }

  async deletePlayer(playername: any) {
    let property = this.scenario.property
    let scen = this.removeKeyAndPropertyFB(this.scenario)
    delete this.scenario.players[playername]
    await set(ref(this.database, 'scenarios/' + property), scen);
    await this.getData()
  }

  // get the number of properties of an object
  getNumberOfKeys(obj: any) {
    let keys = []
    for (let key in obj) {
      keys.push({ id: keys.length, name: key })
    }
    return keys.length
  }
 
  //convert collection to array of objects
  collectionToArray(obj: any) {
    let keys = []
    for (let key in obj) {
      keys.push({ id: keys.length, name: key, ...obj[key] })
    }
    return keys
  }

  updateWorld(){

  }

  gotoScenarioEdit(obj: any){
    let scenario = obj;
    this.router.navigate(['fbscenarioedit'],{ queryParams: { property: scenario.property } })
  }

  newScenarioModal() {
    this.scenario = {key:0,property:this.newScenarioName,name:'',world:'',players:{}}
    this.scenarios.push(this.scenario)
    this.showModalNewScenario = false 
    this.showModal = true  
  }

  async removeOneProperty(path: string, property: string){
    let eventsref = ref(this.database, path);
    let events = await get(eventsref);
    let eventsdt = events.val()
    delete eventsdt[property]
    await set(ref(this.database, path), eventsdt);
  }
  selectScenario(obj: any){
    this.scenario = obj; 
    this.showModal = true
    this.worldkey = this.worldskeys.findIndex((x: any) => x.name == this.scenario.world)
    this.lessonplankey = this.lessonplanskeys.findIndex((x: any) => x.name == this.scenario.lessonplan)
    // loop through all properties of scenario.players and convert timestamp to now timestamp
    for (let key in this.scenario.players) {
      this.scenario.players[key].datetime = this.convertTimestamp(this.scenario.players[key].timestamp)
    }
  }
}
